import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoupleCheckmark1Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDoupleCheckmark1Small"><Path d="M19.3809 7.69336L18.8438 8.53711L13.5938 16.7871L13.0566 17.6309L11.3691 16.5566L11.9062 15.7129L17.1562 7.46289L17.6934 6.61914L19.3809 7.69336ZM15.3779 7.68164L14.8477 8.53027L9.84766 16.5303L9.18164 17.5957L4.58594 13L6 11.5859L8.81738 14.4033L13.1523 7.46973L13.6816 6.62207L15.3779 7.68164Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoupleCheckmark1Small;
